import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import RequestForQuoteForm from "@sunSource/Components/RequestForQuoteForm";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    text = "text",
    color = "color",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.text]: string;
        [fields.color]: string;
    };
}

export interface ServiceCardStyles {}

export const serviceCardStyles: ServiceCardStyles = {};
const styles = serviceCardStyles;

const ServiceCards: React.FC<OwnProps> = ({ fields }) => {
    const containerStyles: InjectableCss = {
        css: css`
            background-color: ${fields.color};
            border-radius: 8px;

            .rich-text {
                padding: 15px;
            }
        `,
    };

    return (
        <>
            <StyledWrapper {...containerStyles}>
                <StyledWrapper className="rich-text">{parse(fields.text, parserOptions)}</StyledWrapper>
                <RequestForQuoteForm successMessage={String(siteMessage("RFQ_Submit_Message"))} />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ServiceCards,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.color,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "white",
            },
            {
                fieldType: "General",
                name: fields.text,
                displayName: "Text",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
